/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react'
import cn from 'classnames'
import classes from '../../style/index.styl'


export interface ToolbarPageInputProps {
  /**
   * 当前页号
   */
  pageNumber: number
  /**
   * 页总数
   */
  pageTotal: number
  /**
   * 页号发生改变
   */
  onPageNumberChange: (pageNo: number) => void
}


export function ToolbarPageInput(props: ToolbarPageInputProps & React.HTMLAttributes<HTMLDivElement>): React.ReactElement {
  const {
    pageTotal,
    pageNumber: currentPageNumber,
    onPageNumberChange,
    ...restProps
  } = props

  const [pageNumber, setPageNumber] = useState<string>('' + currentPageNumber)

  // watch props.pageNumber
  useEffect(() => { setPageNumber('' + currentPageNumber) }, [currentPageNumber])

  // 监听页号输入框的输入事件
  const handlePageNumberInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    setPageNumber(value)
  }

  // 监听页号输入框失去焦点的事件
  const handlePageNumberInputBlur = () => {
    let pn = Number(pageNumber)
    if (Number.isNaN(pn)) pn = currentPageNumber
    else if (pn <= 0) pn = 1
    else if (pn > pageTotal) pn = pageTotal

    setPageNumber('' + pn)
    if (pn !== currentPageNumber) onPageNumberChange(pn)
  }

  // 监听页号输入框的键盘事件
  const handlePageNumberInputKeyPressed = (event: React.KeyboardEvent) => {
    switch (event.key) {
      case 'Enter':
        handlePageNumberInputBlur()
        break
    }
  }

  // 上一页
  const handlePreviousPageButtonPressed = () => {
    if (currentPageNumber <= 1) return
    onPageNumberChange(currentPageNumber - 1)
  }

  // 下一页
  const handleNextPageButtonPressed = () => {
    if (currentPageNumber >= pageTotal) return
    onPageNumberChange(currentPageNumber + 1)
  }

  return (
    <div { ...restProps }>
      <div className={ cn(classes.splitToolbarButton /***, classes.hiddenSmallView */) }>
        <button
          title="上一页"
          tabIndex={ 13 }
          data-l10n-id="previous"
          disabled={ currentPageNumber <= 1 }
          className={ cn(classes.toolbarButton, classes.pageUp) }
          onClick={ handlePreviousPageButtonPressed }
        >
          <span data-l10n-id="previous_label">上一页</span>
        </button>
        <div className={ classes.splitToolbarButtonSeparator } />
        <button
          title="下一页"
          tabIndex={ 14 }
          data-l10n-id="next"
          disabled={ currentPageNumber >= pageTotal }
          className={ cn(classes.toolbarButton, classes.pageDown) }
          onClick={ handleNextPageButtonPressed }
        >
          <span data-l10n-id="next_label">下一页</span>
        </button>
      </div>
      <input
        title="页号"
        tabIndex={ 15 }
        data-l10n-id="page"
        type="text"
        size={ 4 }
        value={ '' + pageNumber }
        className={ cn(classes.toolbarField, classes.pageNumber) }
        onChange={ handlePageNumberInputChange }
        onBlur={ handlePageNumberInputBlur }
        onKeyPress={ handlePageNumberInputKeyPressed }
      />
      <span className={ classes.toolbarLabel }>/ { pageTotal }</span>
    </div>
  )
}


export default ToolbarPageInput
